<template>
    <b-overlay :show="loading" rounded="sm">

        <div class="mb-4">

            <div class="h5 mb-2">
                Anotações
                <span v-b-tooltip.hover title="Clique na imagem abaixo para ver as anotações da sua redação">
                    <svg xmlns="http://www.w3.org/2000/svg" class="icons" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
                    </svg>
                </span>
            </div>

            <b-alert variant="info" dismissible show>
                Para você ver detalhes do seu texto, você pode clicar nas marcações dentro da imagem da redação.
                Se você estiver no celular, use o zoom do seu dispositivo para visualizar melhor a marcação :)
            </b-alert>

            <canvas
                ref="essay"
                class="essay"
                @click="eventClick"
            ></canvas>
        </div>

        <div class="annotation bg-light border-top shadow-sm" v-if="annotation_select">
            <div class="container">
                <b>
                    Comentário da Marcação
                </b>
                <p>
                    {{ annotation_select.msg }}
                </p>
            </div>
        </div>

    </b-overlay>
</template>

<script>
export default {
    props: ['essay'],
    data() {
        return {
            loading: false,
            canvasEl: null,
            context: null,
            width: null,
            height: null,
            posX: null,
            posY: null,
            posFinalX: null,
            posFinalY: null,
            annotations: [],
            annotation_select: null,
            annotation_key: null,
            color: 'rgba(212, 255, 50, 0.40)',
            selectX: 0,
            selectY: 0,
            edit: false,
            isMobile: false,
        }
    },
    mounted() {

        // Canvas
        this.canvasEl = this.$refs.essay;

        // Get Context in 2D
        this.context = this.canvasEl.getContext('2d');
    },
    created() {

        this.isMobile = false;

        // Load
        this.load()
    },
    methods: {

        // Load Essay Annotations
        load(showLoading = true) {
            if (showLoading) {
                this.loading = true;
            }
            axios.get('/student/annotations/' + this.essay.id)
                .then(async (result) => {
                    const response = result.data.data
                    this.annotations = await response.annotations;
                    await this.$emit('annotations', this.annotations)
                    await this.createContextInitial();
                    await this.searchAnnotation();
                })
                .finally(() => {
                    if (showLoading) {
                        this.loading = false
                    }
                })
        },

        // Create Context
        createContextInitial() {
            const imageObj = new Image();
            this.loading = true;

            imageObj.onload = () => {
                this.width = imageObj.width;
                this.height = imageObj.height;
                this.canvasEl.width = this.width;
                this.canvasEl.height = this.height;
                this.context.drawImage(imageObj, 0, 0, this.width,  this.height);
                this.loading = false;

                // Load Annotations
                this.loadAnnotations();
            };

            // Load Image
            imageObj.src = this.essay.preview;
        },

        // Load Annotations
        loadAnnotations() {
            this.annotations.forEach((value, key) => {

                this.context.beginPath();
                this.context.rect(value.posX, value.posY, value.finalX, value.finalY);
                this.context.fillStyle = value.color;

                if (value.edit) {
                    this.context.lineWidth = 2;
                    this.context.strokeStyle = '#333';
                    this.context.stroke();
                }

                this.context.fill();

            });
        },

        // Event Click
        eventClick(event) {
            const rect = this.canvasEl.getBoundingClientRect();

            const scaleX = this.canvasEl.width / rect.width;
            const scaleY = this.canvasEl.height / rect.height;

            const posX = (event.clientX - rect.left) * scaleX;
            const posY = (event.clientY - rect.top) * scaleY;

            this.selectX = posX;
            this.selectY = posY;

            this.searchAnnotation();
        },

        // Search Annotation
        async searchAnnotation() {
            const x = this.selectX;
            const y = this.selectY;

            const finds = [];

            this.annotations.forEach((value, key) => {
                if (x >= value.posX && x <= (value.posX + value.finalX) && y >= value.posY && y <= (value.posY + value.finalY)) {
                    // this.annotations[key]['edit'] = true;
                    finds.push(key);
                    this.createContextInitial();
                } else {
                    this.annotations[key]['edit'] = false;
                    this.createContextInitial();
                }
            });

            if (finds.length === 1) {

                this.annotations[finds[0]]['edit'] = true;
                this.annotation_key = finds[0];
                this.annotation_select = this.annotations[finds[0]];

            } else if (finds.length > 1) {

                this.annotations.forEach((value, key) => {
                    this.annotations[key]['edit'] = false;
                });

                let element_drag = finds[0];

                for (let index = 1; index < finds.length; index++) {

                    let key_small = finds[0];

                    const actual = this.annotations[key_small];
                    const valueX = (actual.posX + actual.finalX) - actual.posX;
                    const valueY = (actual.posY + actual.finalY) - actual.posY;

                    const element = finds[index];
                    const valueCompX = (this.annotations[element]['posX'] + this.annotations[element]['finalX']) - this.annotations[element]['posX'];
                    const valueCompY = (this.annotations[element]['posY'] + this.annotations[element]['finalY']) - this.annotations[element]['posY'];

                    if (valueCompX <= valueX && valueCompY <= valueY) {
                        key_small = element;
                        element_drag = element;
                        this.annotations[element]['edit'] = false;
                    } else {
                        this.annotations[element]['edit'] = false;
                    }

                }

                this.annotations[element_drag]['edit'] = true;
                this.annotation_key = element_drag;
                this.annotation_select = await this.annotations[element_drag];
                await this.createContextInitial();

            } else {
                this.annotation_select = null;
                await this.createContextInitial();
            }
        },
    }
}
</script>

<style scoped>
    .icons{
        height: 20px;
    }

    .essay {
        cursor: pointer;
        width: 100%;
    }

    .essay-mobile {
        cursor: pointer;
    }

    .annotation {
        position: fixed;
        bottom: 0;
        left:0;
        background:#F8F8F8;
        width: 100%;
        border-top: 1px solid #EAEAEA;
        padding: 15px 0;
        z-index: 50;
    }
    .annotation-backdrop {
        background: #333;
        opacity: 0.4;
        position: fixed;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        z-index: 45;
    }
</style>
